var Theme = Theme || {};

Theme.BuyOrUseTokensLink = (function ($) {

    var _accessFullTextLinkSelector = '.access-full-text .js-access-full-text';
    var _lowerTokenLinkSelector = '.token-redeem-container .store-link, .institution-token-redeem-container .store-link';
    var _isPageRedemptionInProgress = false;

    return {
        init: _init
    };

    function _init() {
        $(document).on('click', _accessFullTextLinkSelector + ', ' + _lowerTokenLinkSelector, _guardPageRedemption);
        $(document).on('keydown', _accessFullTextLinkSelector, _followLinkOnSpace);
        $(window).on('pageshow', _reloadIfRestoredMidRedemption);

        var $containers = $('.token-redeem-container, .institution-token-redeem-container');

        if (!$containers.length) {
            return;
        }

        $(document).on('click', '.token-redeem-container .store-link, .institution-token-redeem-container .store-link', function (e) {
            var $link = $(this);

            if ($link.data('token-processing')) {
                e.preventDefault();
                return;
            }

            $link.data('token-processing', true);
            $link.attr('aria-disabled', 'true').addClass('is-processing');
        });
    }

    function _guardPageRedemption(e) {
        if (!$(_accessFullTextLinkSelector).length) {
            return;
        }

        var $control = $(this);
        $control.attr('aria-disabled', 'true').addClass('is-processing');

        if (_isPageRedemptionInProgress || _isLowerTokenLinkProcessing()) {
            e.preventDefault();
            return;
        }

        _isPageRedemptionInProgress = true;

        if ($control.is(_accessFullTextLinkSelector)) {
            _pushAccessFullTextClickEvent($control);
        }
    }

    function _reloadIfRestoredMidRedemption(e) {
        if (!e.originalEvent.persisted || !_isPageRedemptionInProgress) {
            return;
        }

        window.location.reload();
    }

    function _isLowerTokenLinkProcessing() {
        return $(_lowerTokenLinkSelector).filter(function () {
            return $(this).data('token-processing');
        }).length > 0;
    }

    function _followLinkOnSpace(e) {
        if (e.key !== ' ') {
            return;
        }

        e.preventDefault();
        e.currentTarget.click();
    }

    function _pushAccessFullTextClickEvent($link) {
        if (typeof window.dataLayer === 'undefined') {
            return;
        }

        window.dataLayer.push({
            event: 'access_full_text_click',
            resource_id: Number($link.data('resourceId')),
            resource_type: $link.data('resourceType')
        });
    }

})(jQuery);
